import axios from 'axios';
import { handleSessionExpired, isAuthFailure } from './sessionExpiry';
import { API_ORIGIN } from '../config/apiBase';

// In the native app every relative '/api/...' call must resolve against the
// real backend, not the capacitor:// shell. A single global default covers the
// many components that import bare axios; on web this is '' → no-op.
if (API_ORIGIN) {
  axios.defaults.baseURL = API_ORIGIN;
}

// Attach the stored JWT to same-origin API requests so auth-gated endpoints
// (messaging, admin reports, etc.) receive it without every caller wiring it up
// by hand. Scoped to relative/same-origin/API-origin URLs so the token is never
// sent to a third-party host. Skips requests that already set an Authorization
// header.
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const isRelative = url.startsWith('/') && !url.startsWith('//');
  const isSameOrigin =
    /^https?:\/\//i.test(url) &&
    (url.startsWith(window.location.origin) ||
      (API_ORIGIN && url.startsWith(API_ORIGIN)));

  if (isRelative || isSameOrigin) {
    const token = localStorage.getItem('auth-token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  }
  return config;
});

// Tear the session down on the FIRST auth failure rather than letting callers
// retry a token that can never succeed. Pollers listen for the resulting
// 'session-expired' event and stop; the nav bar prompts for a fresh sign-in.
// The original rejection still propagates so per-call error handling is
// unaffected.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAuthFailure(error.response)) {
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);
